import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeSwitcherProvider} from "react-css-theme-switcher";

// SCSS & CSS
import 'antd/dist/antd.min.css';
// import 'antd/dist/antd.css';
import './assets/scss/style.scss';

import AuthContextProvider from "./contexts/AuthContextProvider";
import UserContextProvider from "./contexts/UserContextProvider";
import GlobalContextProvider from "./contexts/GlobalContextProvider";
import RoleContextProvider from "./contexts/RoleContextProvider";
import TableLayoutContextProvider from "./contexts/TableLayoutContextProvider";
import FloorContextProvider from "./contexts/FloorContextProvider";
import ScheduleContextProvider from "./contexts/ScheduleContextProvider";
import RestaurantContextProvider from "./contexts/RestaurantContextProvider";
import RestaurantConfigContextProvider from "./contexts/RestaurantConfigContextProvider";
import ReserveContextProvider from "./contexts/ReserveContextProvider";
import TokenConfigContextProvider from "./contexts/TokenConfigContextProvider";
import RestaurantOwnerContextProvider from "./contexts/RestaurantOwnerContextProvider";

const contextProviders = [
    AuthContextProvider,
    UserContextProvider,
    GlobalContextProvider,
    RoleContextProvider,
    TableLayoutContextProvider,
    FloorContextProvider,
    ScheduleContextProvider,
    RestaurantContextProvider,
    RestaurantConfigContextProvider,
    ReserveContextProvider,
    TokenConfigContextProvider,
    RestaurantOwnerContextProvider,
]

const getAppWithContextProviders = () => {

    let result = <App/>
    contextProviders.forEach(Provider => result = <Provider>{result}</Provider>);

    return result;
}

const themes = {
    dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
}

ReactDOM.render(
    // <React.StrictMode>
    <ThemeSwitcherProvider
        themeMap={themes}
        defaultTheme="dark"
        insertionPoint="styles-insertion-point"
    >
        {getAppWithContextProviders()}
    </ThemeSwitcherProvider>,
    // </React.StrictMode>
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
